import { AccountAPI } from '@/src/api';
import { useApiClient } from '@/src/hooks/api/useApiClient';
import { useTranslation } from 'react-i18next';

export const useAccountApi = () => {
  const { t } = useTranslation();

  return new AccountAPI(useApiClient(), t);
};
